"use client";

import { IUser } from "@/lib/database/schema/user";
import { initMixpanel } from "@/lib/integrations/analytics/mixpanel/mixpanelClient";
import { identify, trackPageView, } from "@/lib/integrations/analytics/tracker";
import { usePathname } from 'next/navigation';
import { useEffect } from "react";

const isDevelopment = process.env.NODE_ENV === "development"

export const MixPanel = ({user}:{user:IUser | null}) => {
  const path = usePathname();

  useEffect(() => {
    if(!isDevelopment) {
      initMixpanel(); // Initialize Mixpanel
    }
  }, []);

  useEffect(() => {
    const handleRouteChange = (url:string) => {
      trackPageView(url); // Track pageviews
    };
    // Track page views on route change
    if(path && !isDevelopment){
      handleRouteChange(path);
    } 
  },[path]);

  useEffect(()=>{
    if(user && !isDevelopment){
      identify(user.id);
    }
  }, [user]);

  return <></>;
}